import { useEffect } from 'react';
import { Form, Input, Button } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import type { Country, CountryFormData } from '@/shared/types';

interface CountryFormProps {
  initialData?: Country;
  onSubmit: (data: CountryFormData) => void;
  isLoading: boolean;
}

export default function CountryForm({ initialData, onSubmit, isLoading }: CountryFormProps) {
  const { t } = useTranslation();
  const [form] = Form.useForm<CountryFormData>();

  useEffect(() => {
    if (initialData) {
      form.setFieldsValue({ nameEn: initialData.nameEn || '', nameAr: initialData.nameAr || '' });
    }
  }, [initialData, form]);

  return (
    <Form form={form} layout="vertical" onFinish={onSubmit} style={{ maxWidth: 480 }}>
      <Form.Item name="nameEn" label={t('countries.nameEn')} rules={[{ required: true }]}>
        <Input placeholder={t('countries.nameEnPlaceholder')} />
      </Form.Item>
      <Form.Item name="nameAr" label={t('countries.nameAr')} rules={[{ required: true }]}>
        <Input dir="rtl" placeholder={t('countries.nameArPlaceholder')} />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={isLoading}>{t('common.save')}</Button>
      </Form.Item>
    </Form>
  );
}
